// extracted by mini-css-extract-plugin
module.exports = {"container":"WhaleFmVideo_container__21lME"};